import { toast } from "react-toastify";
import { deleteItems, updateStateData } from "../Store/actions";
import store from "../Store/store";
import { fetch_adlevel_names, resetCampaignSheetData, restructure_product_information } from "./campaignSheet";
import { filterRegionsAndStores, loadActiveStores, loadStores, updateCampaignStatus } from "./campaigns";
import { createCookie, deleteCookie, sendApiRequest, setBatchLoadingStatus } from "./requestConfig";
import { fetchMarketingActivities } from "./marketingActivities";
import { fetchBrandFilters } from "./brandReport";
import {
  checkStatus,
  dateInCorrectTimezone,
  dbFormatDate,
  formatToStandardDate,
  standardFormatToday,
  fetchWeekNumbers,
  dateObjForToday,
  getFirstDayTwoMonthsAgo,
  erase_duplicates,
} from "./utils";
import platformConfig from "../platformConfig";
import moment from "moment-timezone";
import { checkUserDetailsFromCookie } from "./userManagement";
import { fetchReportSettings } from "./ReportSettings";
import { fetchClipNames } from "./clipRequests";
import { fetchVisualNames } from "./loopCampaign";
import { fetchWorkspaceSections } from "./WorkspaceSections";

const validateCampaignsInfo = (validateFor) => {
  const currentStateData = store.getState().userSelections;
  let error = false;
  let errorMessages = {};

  // campaign name
  const campaignName =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_name !== "undefined"
      ? currentStateData.new_campaign_data.campaign_name
      : "";
  // brand name
  const brandName =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.brand_name !== "undefined"
      ? currentStateData.new_campaign_data.brand_name
      : "";
  // start date
  const startDate =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_start_date !== "undefined"
      ? currentStateData.new_campaign_data.campaign_start_date
      : "";
  // end date
  const endDate =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_end_date !== "undefined"
      ? currentStateData.new_campaign_data.campaign_end_date
      : "";
  // campaign owner id
  const campaignOwnerId =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_owner_id !== "undefined"
      ? currentStateData.new_campaign_data.campaign_owner_id
      : "";
  const checkUserDetails = checkUserDetailsFromCookie();
  // brand company id
  const brandCompanyId =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_brand_company_id !== "undefined"
      ? currentStateData.new_campaign_data.campaign_brand_company_id
      : "";

  const manualBrandCompany =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.manual_brand_company !== "undefined"
      ? currentStateData.new_campaign_data.manual_brand_company
      : false;

  const manualBrandCompanyName =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_brand_company_name !== "undefined"
      ? currentStateData.new_campaign_data.campaign_brand_company_name
      : "";

  const reportStatus =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.report_status !== "undefined"
      ? currentStateData.new_campaign_data.report_status
      : "";

  const impressionStatus =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.impression_status !== "undefined"
      ? currentStateData.new_campaign_data.impression_status
      : "";

  // check campaign
  if (campaignName === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      campaign_name: "Please enter the campaign name",
    };
  }
  // check brandName
  if (brandName === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      brand_name: "Please enter the brand name",
    };
  }
  // check start date
  if (startDate === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      start_date: "Please select the start date for the campaign",
    };
  }
  // check end date
  if (endDate === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      end_date: "Please select the end date for the campaign",
    };
  }

  // validate that start should not be after end date and vice versa
  if (startDate !== "" && endDate !== "") {
    const formattedStartDate = startDate; //dateInCorrectTimezone();
    const formattedEndDate = endDate; //dateInCorrectTimezone();
    //start/end should not be after end date
    if (formattedEndDate < formattedStartDate) {
      error = true;
      errorMessages = {
        ...errorMessages,
        end_date: "End date must be after the start date",
      };
    }
  }

  // retailer company
  if (campaignOwnerId === "" && validateFor !== "update" && checkUserDetails.user_detail.user_type === "cyreen") {
    error = true;
    errorMessages = {
      ...errorMessages,
      campaign_owner: "Please select the owner",
    };
  }
  // brand company
  if (brandCompanyId === "" && manualBrandCompany === false) {
    error = true;
    errorMessages = {
      ...errorMessages,
      brand_company: "Please select the brand company",
    };
  }

  if (manualBrandCompanyName === "" && manualBrandCompany === true) {
    error = true;
    errorMessages = {
      ...errorMessages,
      campaign_brand_company_name: "Please enter the brand company name",
    };
  }

  if (manualBrandCompanyName !== "" && manualBrandCompany === true) {
    // check if the name already exist
    if (
      typeof currentStateData.brand_names_arr !== "undefined" &&
      currentStateData.brand_names_arr.includes(manualBrandCompanyName)
    ) {
      error = true;
      errorMessages = {
        ...errorMessages,
        campaign_brand_company_name: "Brand company name already exists",
      };
    }
  }


  // show error message (if error === true)
  if (error === true) {
    toast("Please fill in valid information", { type: "error" });
    return {
      error: true,
      errorMessages,
    };
  } else {
    let campaignRequestObj = {
      brand: brandName,
      add_new_brand: manualBrandCompany,
      // retailer: parseInt(retailerCompanyId),
      date_end: dbFormatDate(new Date(endDate)),
      date_start: dbFormatDate(new Date(startDate)),
      name: campaignName,
      reporting: true,
      active: false,
      share_list:
        typeof currentStateData.new_campaign_data !== "undefined" &&
          typeof currentStateData.new_campaign_data.share_list !== "undefined"
          ? currentStateData.new_campaign_data.share_list
          : [],
    };

    if (manualBrandCompany === false) {
      campaignRequestObj = {
        ...campaignRequestObj,
        id_company_brand: parseInt(brandCompanyId),
      };
    } else {
      campaignRequestObj = {
        ...campaignRequestObj,
        new_brand_name: manualBrandCompanyName,
      };
    }

    // add campaign id (if found in redux)
    if (
      typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_id !== "undefined" &&
      currentStateData.new_campaign_data.campaign_id !== ""
    ) {
      campaignRequestObj = {
        ...campaignRequestObj,
        id: currentStateData.new_campaign_data.campaign_id,
      };
      // add report status (if available)
      if (
        typeof currentStateData.new_campaign_data !== "undefined" &&
        typeof currentStateData.new_campaign_data.campaign_report_status_code !== "undefined" &&
        [2, 4].includes(currentStateData.new_campaign_data.campaign_report_status_code)
      ) {
        if (reportStatus === true) {
          campaignRequestObj = {
            ...campaignRequestObj,
            campaign_status: 4,
          };
        }
        if (reportStatus === false) {
          campaignRequestObj = {
            ...campaignRequestObj,
            campaign_status: 2,
          };
        }
      }

      if (impressionStatus === true) {
        campaignRequestObj = {
          ...campaignRequestObj,
          impression_status: 1,
        };
      }
    } else {
      campaignRequestObj = {
        ...campaignRequestObj,
        campaign_status: 0,
      };
    }

    // add owner info 
    if (campaignOwnerId !== "" && validateFor !== "update" && checkUserDetails.user_detail.user_type === "cyreen") {
      campaignRequestObj = {
        ...campaignRequestObj,
        id_company_owner: campaignOwnerId,
      };

    }

    // return validated request body for the clips add/update operation
    return {
      error: false,
      campaign_request: campaignRequestObj,
    };
  }
};

// to save/update campaigns
export const saveCampaignsInformation = async (usedfor) => {
  const validateInfo = validateCampaignsInfo(usedfor);
  const currentStateData = store.getState().userSelections;
  let campaignResponse = {};
  if (validateInfo.error === true) {
    campaignResponse = {
      ...campaignResponse,
      success: false,
      errorMessages: validateInfo.errorMessages,
    };
  } else {
    try {
      setBatchLoadingStatus(true)

      let reqEndPoint =
        typeof validateInfo.campaign_request.id !== "undefined" && validateInfo.campaign_request.id !== ""
          ? "campaigns/update"
          : "campaigns/add";
      let reqMethod =
        typeof validateInfo.campaign_request.id !== "undefined" && validateInfo.campaign_request.id !== "" ? "PUT" : "POST";
      // send api request
      const saveCampaignInfo = await sendApiRequest(reqEndPoint, validateInfo.campaign_request, reqMethod);

      if (typeof saveCampaignInfo.success !== "undefined" && saveCampaignInfo.success === true) {
        // check if any error returned from the api
        if (
          typeof saveCampaignInfo.response !== "undefined" &&
          typeof saveCampaignInfo.response.success !== "undefined" &&
          saveCampaignInfo.response.success === false
        ) {
          if (
            typeof saveCampaignInfo.response.message !== "undefined" &&
            saveCampaignInfo.response.message === "DUPLICATE RESOURCES"
          ) {
            campaignResponse = {
              ...campaignResponse,
              success: false,
              errorMessages: {
                campaign_name: saveCampaignInfo?.response?.error_detail,
              },
            };
          } else {
            campaignResponse = {
              ...campaignResponse,
              success: false,
              errorMessages: {
                campaign_brand_company_name: saveCampaignInfo?.response?.error_detail,
              },
            };
          }

          toast("Please fill in valid information", { type: "error" });
        } else {
          const message = usedfor === "update" ? "Campaign updated successfully" : "Campaign added successfully";
          campaignResponse = {
            ...campaignResponse,
            success: true,
            message: message,
          };
          // store.dispatch(deleteItems(["campaign_list_filters", "filtered_campaign_list", "campaign_list_filter_applied"]));
          // deleteCookie("campaign_list_filters", true);
          // manageCampaignPaginationCookie({ scroll_pos: 0 });
          // loadCampaigns(0, currentStateData.campaign_pagination.pageSize);
          Promise.all([
            loadCampaigns(0, currentStateData.campaign_pagination.pageSize),
            fetchCampaignNames(),
            fetchOwnerNames("list-campaigns"),
            fetchIndependentOwnerList(),
          ]).then(() => setBatchLoadingStatus(false));
          toast(message, { type: "success" });
        }
      } else {
        campaignResponse = {
          ...campaignResponse,
          success: false,
          errorMessages: "Sorry, Something went wrong",
        };
      }
    } finally {
      setBatchLoadingStatus(false);
    }
  }
  return campaignResponse;
};

// manage pagination cookie infomation
export const manageCampaignPaginationCookie = (campaignPaginationObj) => {
  const currentStateData = store.getState().userSelections;
  //
  const paginationObj = typeof currentStateData.campaign_pagination !== "undefined" ? currentStateData.campaign_pagination : {};

  store.dispatch(updateStateData({ campaign_pagination: { ...paginationObj, ...campaignPaginationObj } }));
  deleteCookie("campaign_pagination");
  // set cookie for pagination
  createCookie("campaign_pagination", JSON.stringify({ ...paginationObj, ...campaignPaginationObj }));

}

//load campaign list
export const loadCampaigns = async (pageNumber, pageSize) => {
  const currentStateData = store.getState().userSelections;
  // check if page number and page size are passed from the component, if not then set default values.
  if (typeof pageNumber === "undefined" && typeof pageSize === "undefined") {
    pageNumber = 0;
    pageSize = 10;
    // page number/size from the cookies if available
    if (typeof currentStateData.campaign_pagination !== "undefined") {
      pageNumber = currentStateData.campaign_pagination.pageNumber;
      pageSize = currentStateData.campaign_pagination.pageSize;
    }
  }
  //reset campaign list before loading the campaigns (if campaigns are already loaded.)
  resetCampaignSheetData();
  let campaignListApiEndpoint = "campaigns?page=" + pageNumber + "&size=" + pageSize;
  // check if filters are applied, then we need to fetch the filtered list.
  if (
    typeof currentStateData.campaign_list_filter_applied !== "undefined" &&
    typeof currentStateData.campaign_list_filters !== "undefined" &&
    currentStateData.campaign_list_filter_applied === true
  ) {
    // campaign id/name filter
    if (
      typeof currentStateData.campaign_list_filters.campaign_name !== "undefined" &&
      currentStateData.campaign_list_filters.campaign_name.length !== 0
    ) {
      currentStateData.campaign_list_filters.campaign_name.forEach((item) => {
        campaignListApiEndpoint = campaignListApiEndpoint + "&campaign_id=" + item;
      });
    }
    // retailer filter
    if (
      typeof currentStateData.campaign_list_filters.retailer_filter !== "undefined" &&
      currentStateData.campaign_list_filters.retailer_filter.length !== 0
    ) {
      currentStateData.campaign_list_filters.retailer_filter.forEach((item) => {
        campaignListApiEndpoint = campaignListApiEndpoint + "&id_company=" + item;
      });
    }
    // progress filter
    if (
      typeof currentStateData.campaign_list_filters.duration_filter !== "undefined" &&
      currentStateData.campaign_list_filters.duration_filter.length !== 0
    ) {
      currentStateData.campaign_list_filters.duration_filter.forEach((item) => {
        campaignListApiEndpoint = campaignListApiEndpoint + "&progress=" + item;
      });
    }

    // shared filter
    if (
      typeof currentStateData.campaign_list_filters.shared_filter !== "undefined" &&
      currentStateData.campaign_list_filters.shared_filter.length !== 0
    ) {
      currentStateData.campaign_list_filters.shared_filter.forEach((item) => {
        const sharedFilterVal = item === "Yes" ? true : false
        campaignListApiEndpoint = campaignListApiEndpoint + "&share=" + sharedFilterVal;
      });
    }
  }

  const campaignList = await sendApiRequest(campaignListApiEndpoint, {}, "GET");

  if (typeof campaignList.success !== "undefined" && campaignList.success === true) {
    //restructure the campaign list json to fetch only the required data from the response and then save it to redux state
    const getRestructuredData = restructureCampaignData(campaignList.response.content);

    store.dispatch(
      updateStateData({
        campaign_list: getRestructuredData,
      })
    );
    // save/update campaign pagination info
    manageCampaignPaginationCookie({
      totalPages: campaignList.response.totalPages,
      totalRecords: campaignList.response.totalElements,
      pageNumber: campaignList.response.number,
      pageSize: campaignList.response.size,
    });

    // scroll to the top of page
    window.scrollTo(0, 0);

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

export const loadCampaignsForUsers = async (ownerId) => {
  const currentStateData = store.getState().userSelections;
  //reset campaign list before loading the campaigns (if campaigns are already loaded.)
  resetCampaignSheetData();
  let endpoint = "campaigns/exclusive-list";
  if (typeof ownerId !== "undefined" && ownerId !== "") {
    endpoint = endpoint + "?owner_id=" + ownerId;
  }
  const campaignList = await sendApiRequest(endpoint, {}, "GET");

  if (typeof campaignList.success !== "undefined" && campaignList.success === true) {
    //restructure the campaign list json to fetch only the required data from the response and then save it to redux state
    const getRestructuredData = restructureCampaignNameData(campaignList.response);

    store.dispatch(
      updateStateData({
        exclusive_campaign_list: getRestructuredData,
      })
    );

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

//Get the max timeframe where at least one store is open
export const getStoresAvailableHours = async (storeIds = [], slelectedDays = []) => {

  const weekdays = slelectedDays.map(day => ({ Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 })[day]);

  if (!Array.isArray(storeIds) || storeIds.length === 0) {
    return { success: false, message: "storeIds has to be and not empty Array" };
  }

  try {
    const body = { storeIds, weekdays };

    const response = await sendApiRequest("stores/available-hours", body,
      "POST"
    );

    if (!response.success) {
      return { success: false, message: "API-ERROR" };
    }

    if (slelectedDays.length >= 1) {
      //Save available hours in Redux
      store.dispatch(
        updateStateData({
          stores_available_hours: response.response.openedHours,
        })
      );
    } else {
      store.dispatch(
        updateStateData({
          stores_available_weekdays: response.response.weekdays,
          stores_available_hours: []
        })
      );
    }

    return { success: true, message: response.response };
  } catch (err) {
    return { success: false, message: "API-ERROR" };
  }
};

// fetch campaign names for filters/dropdowns etc.
export const fetchCampaignNames = async () => {
  const campaignList = await sendApiRequest("campaigns/list", {}, "GET");
  if (typeof campaignList.success !== "undefined" && campaignList.success === true) {
    const fetchStructuredInfo = restructureCampaignNameData(campaignList.response);

    store.dispatch(
      updateStateData({
        campaign_names_info: fetchStructuredInfo,
      })
    );

    return {
      success: true,
      data: fetchStructuredInfo,
    };
  } else {
    return {
      success: false,
      data: null,
    };
  }
};

// fetch independent owner list for add campaign/clips/pictures etc. 
export const fetchIndependentOwnerList = async () => {
  const ownerList = await sendApiRequest("companies", {}, "GET");
  if (typeof ownerList.success !== "undefined" && ownerList.success === true) {
    let campaignCompanyList = []
    ownerList.response.forEach((owner) => {
      // campaign company name list
      campaignCompanyList.push({ id: owner.id, label: owner.name, company_level: owner.level, visual_upload_limit: owner.loop_visual_limit, visual_upload_duration: owner.loop_visual_max_duration });
    })

    store.dispatch(
      updateStateData({
        independent_owners_list: campaignCompanyList,
      })
    );

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

// fetch owner names for filters/dropdowns etc.
export const fetchOwnerNames = async (requestedFor) => {
  const ownerList = await sendApiRequest("companies/" + requestedFor, {}, "GET");
  if (typeof ownerList.success !== "undefined" && ownerList.success === true) {
    let campaignCompanyList = []
    ownerList.response.forEach((owner) => {
      // campaign company name list
      campaignCompanyList.push({ id: owner.id, label: owner.name });
    })

    store.dispatch(
      updateStateData({
        companies_info: campaignCompanyList,
      })
    );

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

const restructureCampaignNameData = (campaignListDetails) => {
  let campaignNameArray = [];
  let campaignNameList = [];
  let activeCampaignNameList = [];
  let campaignDatesList = {};
  let campaignNameFullObj = [];
  let report_available_campaigns = [];

  campaignListDetails.forEach((campaign) => {
    campaignNameFullObj.push(campaign);
    //we will only show those campaigns for which reporting has to be done.
    const campaignProgressStatus = checkStatus(campaign.date_start, campaign.date_end);
    //create a campaign name array for filters
    if (!campaignNameArray.includes(campaign.name)) {
      campaignNameArray.push(campaign.name);
    }
    //create a campaign name array for filters
    if (!Object.values(campaignNameList).includes(campaign.name)) {
      campaignNameList.push({ id: campaign.id, label: campaign.name });
      campaignDatesList = {
        ...campaignDatesList,
        [campaign.id]: {
          campaign_start_date: campaign.date_start,
          campaign_end_date: campaign.date_end,
        },
      };
      //
      if (["Active", "Scheduled"].includes(campaignProgressStatus)) {
        activeCampaignNameList.push({ id: campaign.id, label: campaign.name });
      }
    }
    // filter campaigns for which report is available.
    if (campaign.campaign_status === 4) {
      const checkUserDetail = checkUserDetailsFromCookie();
      // need to filter campaigns that belong to logged user if it's not cyreen user
      if (typeof checkUserDetail.user_detail.user_type !== "undefined" && checkUserDetail.user_detail.user_type !== "cyreen") {
        if (campaign.company_retailer.name === checkUserDetail.user_detail.assigned_company.name) {
          report_available_campaigns.push({ id: campaign.id, label: campaign.name, brand_name: campaign.brand, brand_company: campaign.company_brand.name, end_date: campaign.date_end });
        }
      } else {
        report_available_campaigns.push({ id: campaign.id, label: campaign.name, brand_name: campaign.brand, brand_company: campaign.company_brand.name, end_date: campaign.date_end });
      }
    }
  });

  return {
    campaign_name_list: campaignNameArray,
    campaign_name_obj: campaignNameList,
    campaign_dates_list: campaignDatesList,
    active_campaign_name_list: activeCampaignNameList,
    campaign_name_full_obj: campaignNameFullObj,
    report_available_campaigns: report_available_campaigns
  };
};

//fetch single campaign
export const fetchCampaign = async (campaignid, requestFor = "all", viewMode, accessFor = "list") => {
  setBatchLoadingStatus(true)
  const campaignDetail = await sendApiRequest("campaigns/" + campaignid, {}, "GET");
  const currentStateData = store.getState().userSelections;
  if (typeof campaignDetail.success !== "undefined" && campaignDetail.success === true) {
    const record = campaignDetail.response;
    if (typeof record.error !== "undefined" && record.error === true) {
      toast("Campaign data not found", { type: "error" });
      setTimeout(() => {
        window.location.href = "/check-campaigns/list";
      }, 2000);
    } else {
      // save data in redux
      store.dispatch(
        updateStateData({
          campaign_detail: {
            campaign_id: record.id,
            campaign_name: record.name,
            campaign_start_date: record.date_start,
            campaign_end_date: record.date_end,
            brand: record.brand,
            retailer_company_id: record.company_retailer.id,
            retailer_company_name: record.company_retailer.name,
            brand_company_id: record.company_brand.id,
            brand_company_name: record.company_brand.name,
            retailer: record.company_brand.id === 40 ? "REWE" : "EDEKA",
            notes: record.notes,
            tableau_project_id: record.tableauId,
            campaign_status_code: record.campaign_status,
            impression_report_status: record.impression_status === null ? 0 : record.impression_status,
            workbook_path: record.workbookPath,
            campaign_active_status: checkStatus(record.date_start, record.date_end),
            assignedUser: record.assignedUser,
            datasourceVersion: record.datasourceVersion,
            retailer_id: record.company_retailer.id, //record.company_brand.id === 40 ? 40 : 2,
            workbook_id: record.workbookId,
            campaign_stores: record?.store_names,
            root_company_id: record?.root_company_id,
            campaign_analytics_config:
              record?.campaign_analytics_config !== null
                ? record?.campaign_analytics_config.filter(tab => {
                  return tab !== null
                })
                  .sort((a, b) => {
                    return a.tab_position - b.tab_position;
                  })
                  .filter((tabConfig) => {
                    return tabConfig.tab_visible;
                  })
                : [],
          },
        })
      );
    }

    if (requestFor === "all") {
      //load adlevels for this campaign
      // await checkProductInformation(campaignid, true);

      // // // load marketing activity information
      // await fetchMarketingActivities(campaignid);

      // // // load campaign weeks
      // await fetchWeekNumbers(record.date_start, record.date_end);

      // // // load stores
      // await loadStores();

      // // // fetch brand report filters
      const userRole = currentStateData?.brand_report_view === true ? "Brand" : viewMode;

      // await fetchReportSettings(campaignid).then(info => {
      //   fetchBrandFilters(campaignid, userRole);
      // });

      const requiredRequests = [
        checkProductInformation(campaignid, true),
        fetchMarketingActivities(campaignid),
        fetchWeekNumbers(record.date_start, record.date_end),
        // loadStores(),
        fetchWorkspaceSections(),
        // fetchClipNames(),
        // fetchCampaignNames(),
        // fetchVisualNames(),
      ]

      if (accessFor === "preview") {
        requiredRequests.push(loadStores().then(() => {
          fetchBrandFilters(campaignid, userRole)
        }));
      } else {
        // report settings only need to be fethched while accessing camapaign analytics. Else it will overwrite the changes during preview mode. Since preview will show how the new settings will reflect.
        // requiredRequests.push(loadStores())
        requiredRequests.push(fetchRegionsForCampaign(campaignid))
        requiredRequests.push(fetchNielsenRegionsForCampaign(campaignid))
        requiredRequests.push(
          fetchReportSettings(campaignid).then(info => {
            return loadStores().then(() => {
              fetchBrandFilters(campaignid, userRole)
            })
          })
        );
      }


      await Promise.all(requiredRequests);

      // Promise.all([
      //   checkProductInformation(campaignid, true),
      //   fetchMarketingActivities(campaignid),
      //   fetchWeekNumbers(record.date_start, record.date_end),
      //   loadStores(),
      //   fetchReportSettings(campaignid).then(info => {
      //     fetchBrandFilters(campaignid, userRole);
      //   })
      // ])
    } else {
      if (requestFor === "products") {
        //load adlevels for this campaign
        await checkProductInformation(campaignid, true);
      }
      if (requestFor === "marketing_activity") {
        //load adlevels for this campaign
        await checkProductInformation(campaignid, true);

        // // load campaign weeks
        await fetchWeekNumbers(record.date_start, record.date_end);

        // // load stores first so store_names are available when fetchMarketingActivities runs
        // await loadStores();
        await loadActiveStores();
        await filterRegionsAndStores();

        // // load marketing activity information
        await fetchMarketingActivities(campaignid);
      }
    }

    setBatchLoadingStatus(false)

    return {
      success: true,
    };
  } else {
    window.location.href = "/login";
  }
};

//sort campaigns by start date
const sortByStartDate = (campaignArray) => {
  return campaignArray.sort((next, prev) => {
    return formatToStandardDate(prev.campaign_start_date) - formatToStandardDate(next.campaign_start_date);
  });
};

export const compareDates = (startDate, compare = "start") => {
  const dateStrForToday = dateObjForToday(new Date());
  const today = moment.tz(dateStrForToday, platformConfig.timezone).startOf("day");
  const start = moment.tz(startDate, platformConfig.timezone).startOf("day");

  // Calculate the difference in days
  const daysDifference = today.diff(start, "days");

  let response = { daysDifference: 0 };

  if (today.isSame(start, "day")) {
    response = {
      ...response,
      status: compare === "start" ? "started_today" : "ended_today",
    };
  }

  if (today.isAfter(start, "day")) {
    response = {
      ...response,
      status: compare === "start" ? "started_days_ago" : "ended_days_ago",
      daysDifference: daysDifference,
    };
  }

  return response;
};

// this function will check campaign status based on start/end date and add only the required information to the final array which will be returned.
const restructureCampaignData = (campaignListDetails) => {
  let restructuredActiveData = [];
  let restructuredScheduledData = [];
  let restructuredCompletedData = [];
  let restructuredAllCampaigns = [];
  let campaignNameArray = [];
  let campaignNameList = [];
  let activeCampaignNameList = [];
  let campaignCompanyList = [];
  let report_available_campaigns = [];

  let campaignDatesList = {};

  campaignListDetails.forEach((campaign) => {
    //we will only show those campaigns for which reporting has to be done.
    if (campaign.reporting === true) {
      //decide campaign status by comparing current date with start and end date of campaign.
      const currentDate = standardFormatToday();
      const campaignStartDate = formatToStandardDate(campaign.date_start);
      const campaignEndDate = formatToStandardDate(campaign.date_end);
      const checkCampaignStartStatus = compareDates(campaign.date_start);
      const checkCampaignEndStatus = compareDates(campaign.date_end, "enddate");
      const campaignProgressStatus = checkStatus(campaign.date_start, campaign.date_end);
      let campaignDataObj = {
        campaign_id: campaign.id,
        campaign_name: campaign.name,
        campaign_start_date: campaign.date_start,
        campaign_end_date: campaign.date_end,
        brand: campaign.brand,
        retailer_company_id: campaign.company_retailer.id,
        retailer_company_name: campaign.company_retailer.name,
        brand_company_id: campaign.company_brand.id,
        brand_company_name: campaign.company_brand.name,
        retailer: campaign.company_brand.id === 40 ? "REWE" : "EDEKA",
        // retailer: campaign.company_brand.name,
        notes: campaign.notes,
        tableau_project_id: campaign.tableauId,
        campaign_status_code: campaign.campaign_status,
        impression_report_status: campaign.impression_status === null ? 0 : campaign.impression_status,
        campaign_start_status: checkCampaignStartStatus.status,
        campaign_end_status: checkCampaignEndStatus.status,
        days_passed: checkCampaignStartStatus.daysDifference,
        workbook_path: campaign.workbookPath,
        campaign_active_status: campaign.active,
        assignedUser: campaign.assignedUser,
        datasourceVersion: campaign.datasourceVersion,
        workbook_id: campaign.workbookId,
        last_edit: campaign.last_edit,
        share_list: typeof campaign.share_list !== "undefined" && campaign.share_list !== null ? campaign.share_list : [],
        shared: campaign.shared,
        optimization: {
          days: false,
          hours: true,
          stores: true,
        },
        location: {
          regions: 1,
          stores: 10,
          screen: 25,
          region_names: ["Saxony"],
        },
      };
      //create a retailer array for filters
      // if (!reatilersArray.includes(campaign.company_brand.name)) {
      //   reatilersArray.push(campaign.company_brand.name);
      // }

      // status = Scheduled
      if (campaignProgressStatus === "Scheduled") {
        campaignDataObj = {
          ...campaignDataObj,
          campaign_status: campaignProgressStatus,
        };
        restructuredScheduledData.push(campaignDataObj);
      }
      // status = Completed
      if (campaignProgressStatus === "Completed") {
        campaignDataObj = {
          ...campaignDataObj,
          campaign_status: "Completed",
        };
        restructuredCompletedData.push(campaignDataObj);
      }
      //status = Active
      if (campaignProgressStatus === "Active") {
        campaignDataObj = {
          ...campaignDataObj,
          campaign_status: "Active",
        };
        restructuredActiveData.push(campaignDataObj);
      }

      //create a campaign name array for filters
      if (!campaignNameArray.includes(campaign.name)) {
        campaignNameArray.push(campaign.name);
      }
      //create a campaign name array for filters
      if (!Object.values(campaignNameList).includes(campaign.name)) {
        campaignNameList.push({ id: campaign.id, label: campaign.name });
        campaignDatesList = {
          ...campaignDatesList,
          [campaign.id]: {
            campaign_start_date: campaign.date_start,
            campaign_end_date: campaign.date_end,
          },
        };
        //
        if (["Active", "Scheduled"].includes(campaignDataObj.campaign_status)) {
          activeCampaignNameList.push({ id: campaign.id, label: campaign.name });
        }
        if (campaign.campaign_status === 4) {
          const checkUserDetail = checkUserDetailsFromCookie();
          // need to filter campaigns that belong to logged user if it's not cyreen user
          if (typeof checkUserDetail.user_detail.user_type !== "undefined" && checkUserDetail.user_detail.user_type !== "cyreen") {
            if (campaign.company_retailer.name === checkUserDetail.user_detail.assigned_company.name) {
              report_available_campaigns.push({ id: campaign.id, label: campaign.name });
            }
          } else {
            report_available_campaigns.push({ id: campaign.id, label: campaign.name });
          }
        }
      }
      // campaign company name list
      campaignCompanyList.push({ id: campaign.company_retailer.id, label: campaign.company_retailer.name });
      // all campaigns (irrespective of status)
      restructuredAllCampaigns.push(campaignDataObj);
    }
  });

  return {
    all_campaigns: restructuredAllCampaigns,// sortByStartDate(restructuredAllCampaigns),
    // live_campaigns_list: sortByStartDate(restructuredActiveData),
    // scheduled_campaigns_list: sortByStartDate(restructuredScheduledData),
    // completed_campaigns_list: sortByStartDate(restructuredCompletedData),
    retailer_keywords: ["EDEKA", "REWE"],
    campaign_name_list: campaignNameArray,
    campaign_name_obj: campaignNameList,
    campaign_dates_list: campaignDatesList,
    active_campaign_name_list: activeCampaignNameList,
    campaign_company_list: campaignCompanyList,
    report_available_campaigns: report_available_campaigns,
  };
};

//update campaign data i.e., notes, active, status, workbook path, and tableau project id
export const updateCampaignData = async (requestBody, campaign_id) => {
  //save project id and update campaign status to be 2 i.e., data processing
  const updateData = await sendApiRequest("campaigns/data/update/" + campaign_id, requestBody, "PUT");

  if (typeof updateData.success !== "undefined" && updateData.success === true) {
    /*
      fetch campaign details once the data is updated 
      (it will automatically update the redux state with latest data)
    */
    fetchCampaign(campaign_id, "all");
    return {
      success: true,
      message: "Data updated successfully.",
    };
  } else {
    return {
      success: false,
      message: "Sorry, something went wrong.",
    };
  }
};

// to save new adlevel row
export const saveSingleAdlevelRow = async (campaign_id, adlevelObj, campaignStatusUpdate) => {
  //cross check if adlevels are added in redux store or not
  if (typeof adlevelObj !== "undefined" && adlevelObj.length !== 0) {
    const saveAdlevelResponse = await sendApiRequest("products/data/add", adlevelObj, "POST");

    if (saveAdlevelResponse.success === true) {
      // check if any error returned from the api
      if (
        typeof saveAdlevelResponse.response !== "undefined" &&
        typeof saveAdlevelResponse.response.success !== "undefined" &&
        saveAdlevelResponse.response.success === false
      ) {
        //no need to perform any action (it's unsure whether success param will be there in the actual success response, that's why temporarily we need to leave this block empty)
      } else {
        //update campaign status
        if (campaignStatusUpdate.toString() !== "3") {
          updateCampaignStatus(3, campaign_id);
        }
        fetchCampaign(campaign_id, "products");
      }
      return {
        success: true,
        api_response: saveAdlevelResponse,
      };
    }
  } else {
    return {
      success: false,
    };
  }
};

//save adlevels to the backend database
export const saveCampaignAdlevels = async (campaign_id) => {
  const currentStateData = store.getState().userSelections;
  //cross check if adlevels are added in redux store or not
  if (typeof currentStateData.adlevel_sheet_data !== "undefined" && currentStateData.adlevel_sheet_data.length !== 0) {
    const saveAdlevelResponse = await sendApiRequest("products/data/add", currentStateData.adlevel_sheet_data, "POST");

    if (saveAdlevelResponse.success === true) {
      // check if any error returned from the api
      if (
        typeof saveAdlevelResponse.response !== "undefined" &&
        typeof saveAdlevelResponse.response.success !== "undefined" &&
        saveAdlevelResponse.response.success === false
      ) {
        //no need to perform any action (it's unsure whether success param will be there in the actual success response, that's why temporarily we need to leave this block empty)
      } else {
        //update campaign status to be 1 i.e., product information saved
        // updateCampaignData({ status: 1 }, campaign_id);
        /*
          * 28 April 2025 : 
          * commented out the update campaign status api call because we are managing the status from backend now.
        */
        // updateCampaignStatus(3, campaign_id);
        //loadCampaigns();
        //fetchCampaign(campaign_id, "products");
        //reset adlevels in redux
        store.dispatch(
          updateStateData({
            adlevel_sheet_data: [],
            adlevels_saved: true,
          })
        );
      }
      return {
        success: true,
        api_response: saveAdlevelResponse,
      };
    }
  } else {
    return {
      success: false,
    };
  }
};

// to add a new adlevel manually
export const addNewProductAdlevels = async (campaign_id, adlevelRequestParam) => {
  const saveAdlevelResponse = await sendApiRequest("products/data/add", adlevelRequestParam, "POST");

  if (saveAdlevelResponse.success === true) {
    // update campaign status
    updateCampaignStatus(3, campaign_id);
    //send a request at backend to fetch latest data.
    checkProductInformation(campaign_id);
    return {
      success: true,
      api_response: saveAdlevelResponse,
    };
  } else {
    return {
      success: false,
    };
  }
};

//update adlevels (Product information)
export const updateCampaignAdlevels = async (adlevelRecords) => {
  const currentStateData = store.getState().userSelections;
  //cross check if adlevels are added in redux store or not
  if (typeof adlevelRecords !== "undefined" && adlevelRecords.length !== 0) {
    const saveAdlevelResponse = await sendApiRequest("products/data/update", adlevelRecords, "PUT");

    if (saveAdlevelResponse.success === true) {
      //reset adlevels in redux and show a link to check saved adlevels
      store.dispatch(
        updateStateData({
          adlevels_updated: true,
        })
      );
      return {
        success: true,
      };
    }
  } else {
    return {
      success: false,
    };
  }
};

//delete single adlevel based on id
export const deleteSingleAdlevel = async (adlevelId) => {
  const currentStateData = store.getState().userSelections;
  //cross check if adlevels are added in redux store or not
  if (typeof currentStateData.created_adlevels !== "undefined" && currentStateData.created_adlevels.length !== 0) {
    const deleteAdlevelResponse = await sendApiRequest("products/data/delete/" + adlevelId, "", "DELETE");

    if (deleteAdlevelResponse.success === true) {
      return {
        success: true,
        message: "adlevel deleted",
      };
    } else {
      return {
        success: false,
        message: "Sorry, something went wrong.",
      };
    }
  }
};

// delete multiple adlevels
export const deleteMultipleAdlevels = async (toBeDeletedRecords) => {
  const currentStateData = store.getState().userSelections;
  if (typeof currentStateData.created_adlevels !== "undefined" && currentStateData.created_adlevels.length !== 0) {
    //call backend api to delete multiple adlevels.
    const deleteAdlevelsResponse = await sendApiRequest("products/data/delete", toBeDeletedRecords, "DELETE");
    //return response.
    if (deleteAdlevelsResponse.success === true) {
      return {
        success: true,
        message: "adlevel deleted",
      };
    } else {
      return {
        success: false,
        message: "Sorry, something went wrong.",
      };
    }
  }
};

//fetch adlevel details based on campaign id
export const checkProductInformation = async (campaign_id, adlevel = false) => {
  const checkInfoResponse = await sendApiRequest("products/campaign/" + campaign_id, "", "GET");
  if (checkInfoResponse.success === true) {
    /*
    need to restructure the product information response to match the created_adlevel 
    format which is formed at the time when ad levels are created from upload campaign 
    sheet page.
    */
    const restructuredData = restructure_product_information(checkInfoResponse.response, campaign_id);
    if (adlevel === true) {
      fetch_adlevel_names(restructuredData.restructuredData);
    }
  }
};

//fetch stores list from backend
export const fetchStores = async (retailer_id) => {
  const checkStoresResponse = await sendApiRequest("stores", "", "GET");

  if (checkStoresResponse.success === true) {
    /*need to filter stores based on the reatailer id.*/
    filter_stores(retailer_id, checkStoresResponse.response.content);
  }
};

//to filter stores based on retailer id
const filter_stores = (retailerId, storesListResponse) => {
  let filteredData = [];
  let storeIdList = {};
  //traverse all the records from campaignData
  storesListResponse.forEach((store) => {
    if (store.retailer_id === retailerId) {
      filteredData.push({ value: store.id, label: store.name });
      storeIdList = {
        ...storeIdList,
        [store.id]: {
          name_store: store.name,
          id_region: store.region.id,
          market_type: store.id_market_type,
        },
      };
    }
  });

  //save to redux
  store.dispatch(
    updateStateData({
      stores_list: filteredData,
      stores_detail: storeIdList,
    })
  );

  return {
    filteredData,
  };
};

//to match campaign list records with the filters applied.
const matchRecords = (item) => {
  const currentStateData = store.getState().userSelections;
  const appliedFilters = currentStateData.campaign_list_filters;
  const campaignStartDate = dateInCorrectTimezone(item.campaign_start_date);
  const campaignEndDate = dateInCorrectTimezone(item.campaign_end_date);
  let itemMatch = true;
  //retailer filter
  if (appliedFilters.retailer_filter.length !== 0) {
    if (!appliedFilters.retailer_filter.find((retailer) => retailer.label === item.retailer_company_name)) {
      return false;
    }
  }
  //assigned to
  if (appliedFilters.assigned_to_filter.length !== 0) {
    if (!appliedFilters.assigned_to_filter.includes(item.assignedUser)) {
      return false;
    }
  }
  //status filter
  if (appliedFilters.status_filter.length !== 0) {
    if (!appliedFilters.status_filter.includes(item.campaign_status_code.toString())) {
      return false;
    }
  }
  //campaign name filter
  if (appliedFilters.campaign_name.length !== 0) {
    if (!appliedFilters.campaign_name.includes(item.campaign_id)) {
      return false;
    }
  }

  //when only start date is selected
  // if (appliedFilters.startdate_filter !== "" && appliedFilters.enddate_filter === "") {
  //   const filterStartDate = dateInCorrectTimezone(appliedFilters.startdate_filter);
  //   if (campaignStartDate >= filterStartDate) {
  //     itemMatch = true;
  //   }
  // }
  //when only end date is selected
  // if (appliedFilters.enddate_filter !== "" && appliedFilters.startdate_filter === "") {
  //   const filterEndDate = dateInCorrectTimezone(appliedFilters.enddate_filter);
  //   if (campaignEndDate <= filterEndDate) {
  //     itemMatch = true;
  //   }
  // }
  //when both start and end dates are selected
  // if (appliedFilters.enddate_filter !== "" && appliedFilters.startdate_filter !== "") {
  //   const filterStartDate = dateInCorrectTimezone(appliedFilters.startdate_filter);
  //   const filterEndDate = dateInCorrectTimezone(appliedFilters.enddate_filter);
  //   if (campaignStartDate >= filterStartDate && campaignEndDate <= filterEndDate) {
  //     itemMatch = true;
  //   }
  // }
  // when duration/progress filter is applied
  if (appliedFilters.duration_filter.length !== 0) {
    if (!appliedFilters.duration_filter.includes(item.campaign_status)) {
      return false;
    }
  }

  return itemMatch;
};

//filter campaigns according to the filters applied
export const filterCampaigns = () => {
  const currentStateData = store.getState().userSelections;
  let filteredLive = [];
  let filteredCompleted = [];
  let filteredScheduled = [];
  const appliedFilters = currentStateData.campaign_list_filters;

  //filter live campaigns
  if (
    typeof currentStateData.campaign_list !== "undefined" &&
    typeof currentStateData.campaign_list.all_campaigns !== "undefined" &&
    currentStateData.campaign_list.all_campaigns.length !== 0
  ) {
    currentStateData.campaign_list.all_campaigns.forEach((item) => {
      const checkMatch = matchRecords(item);
      if (checkMatch === true) {
        filteredLive.push(item);
      }
    });
  }

  //filter completed campaigns
  // if (
  //   typeof currentStateData.campaign_list !== "undefined" &&
  //   typeof currentStateData.campaign_list.completed_campaigns_list !== "undefined" &&
  //   currentStateData.campaign_list.completed_campaigns_list.length !== 0
  // ) {
  //   currentStateData.campaign_list.completed_campaigns_list.forEach((item) => {
  //     const checkMatch = matchRecords(item);
  //     if (checkMatch === true) {
  //       filteredCompleted.push(item);
  //     }
  //   });
  // }

  //filter scheduled campaigns
  // if (
  //   typeof currentStateData.campaign_list !== "undefined" &&
  //   typeof currentStateData.campaign_list.scheduled_campaigns_list !== "undefined" &&
  //   currentStateData.campaign_list.scheduled_campaigns_list.length !== 0
  // ) {
  //   currentStateData.campaign_list.scheduled_campaigns_list.forEach((item) => {
  //     const checkMatch = matchRecords(item);
  //     if (checkMatch === true) {
  //       filteredScheduled.push(item);
  //     }
  //   });
  // }

  store.dispatch(
    updateStateData({
      filtered_campaign_list: {
        all_campaigns: filteredLive,
        // live_campaigns_list: filteredLive,
        // scheduled_campaigns_list: filteredScheduled,
        // completed_campaigns_list: filteredCompleted,
      },
      campaign_list_filter_applied: true,
    })
  );

  return true;
};

// execute ETL scripts
export const executeEtl = async () => {
  const currentStateData = store.getState().userSelections;
  //subtract 2 minutes from current date and time, (Airflow requirement)
  const logical_date = new Date().setMinutes(new Date().getMinutes() - 2);
  const etlRequestBody = {
    conf: {
      arg1: currentStateData.campaign_detail.retailer_id,
      arg2: currentStateData.campaign_detail.campaign_id,
      arg3: "3",
    },
    dag_run_id: "etl_script_for_" + currentStateData.campaign_detail.campaign_id + "_" + Math.floor(Math.random() * 1000),
    logical_date: new Date(logical_date),
    note: "",
  };
  const checkEtlResponse = await sendApiRequest("etl/call", etlRequestBody, "POST");

  if (checkEtlResponse.success === true) {
    toast("ETL Request has been queued. It may take some time to complete", { type: "success" });
  } else {
    toast("Sorry, something went wrong.", { type: "error" });
  }
  return checkEtlResponse;
};

export const clearfilters = () => {
  // deleteCookie("campaign_list_filters");
  // deleteCookie("clip_list_filters");
  // deleteCookie("pic_list_filters");
  //reset campaign listing
  // store.dispatch(
  //   deleteItems([
  //     "campaign_list_filters",
  //     "filtered_campaign_list",
  //     "campaign_list_filter_applied",
  //     "clip_list_filters",
  //     "filtered_clips_list",
  //     "clips_list_filter_applied",
  //     "pic_list_filters",
  //     "filtered_pictures_list",
  //     "pics_list_filter_applied",
  //   ])
  // );
};

// save stores detail to backend db
export const addStore = async (requestBody) => {
  const checkStoreResponse = await sendApiRequest("stores/add", requestBody, "POST");
  //return response.
  if (checkStoreResponse.success === true) {
    return {
      success: true,
      message: "store added",
    };
  } else {
    return {
      success: false,
      message: "Sorry, something went wrong.",
    };
  }
};

// download campaign data
export const downloadCampaignData = async (campaignName, dataOption) => {
  const downloadUrl = await sendApiRequest(
    "api/bucket/download-excel",
    {
      campaign_name: campaignName,
      export_type: dataOption,
    },
    "POST"
  );
  if (typeof downloadUrl.success !== "undefined" && downloadUrl.success === true) {
    if (typeof downloadUrl.response.error_detail !== "undefined" && downloadUrl.response.error_detail !== "") {
      toast(downloadUrl.response.error_detail, { type: "error" });
    } else {
      // download impressions
      if (typeof downloadUrl.response.impressions !== "undefined" && downloadUrl.response.impressions !== null) {
        window.location = downloadUrl.response.impressions;
      }
      // download conversion data - total
      if (
        typeof downloadUrl.response.performance_aggregate !== "undefined" &&
        downloadUrl.response.performance_aggregate !== null
      ) {
        if (downloadUrl.response.impressions === null && downloadUrl.response.performance_store === null) {
          window.location = downloadUrl.response.performance_aggregate;
        } else {
          setTimeout(() => {
            window.location = downloadUrl.response.performance_aggregate;
          }, 1000);
        }
      }

      // download conversion data - stores
      if (
        typeof downloadUrl.response.performance_store !== "undefined" &&
        downloadUrl.response.performance_store !== null
      ) {
        if (downloadUrl.response.impressions === null && downloadUrl.response.performance_aggregate === null) {
          window.location = downloadUrl.response.performance_store;
        } else {
          setTimeout(() => {
            window.location = downloadUrl.response.performance_store;
          }, 2000);
        }
      }
    }
  } else {
    return {
      success: false,
      message: "Sorry, something went wrong",
    };
  }
};

// return campaign names that aren't older than 2 months.
export const campaign_names_in_range = () => {
  var campaign_name_obj = [{}];
  const currentStateData = store.getState().userSelections;
  const firstDayTwoMonthsAgo = formatToStandardDate(getFirstDayTwoMonthsAgo());
  firstDayTwoMonthsAgo.setDate(firstDayTwoMonthsAgo.getDate() + 1);
  const today = standardFormatToday();
  const yesterday = formatToStandardDate(today);
  yesterday.setDate(today.getDate() - 1);

  currentStateData.campaign_names_info.campaign_name_full_obj.forEach((campaign_obj) => {
    if (formatToStandardDate(campaign_obj.date_end) > firstDayTwoMonthsAgo) {
      campaign_name_obj.push({ id: campaign_obj.id, label: campaign_obj.name });
    }
  });
  return erase_duplicates(campaign_name_obj);
};

export const clip_names_in_range = (usedFor) => {
  var clip_name_obj = [{}];
  const currentStateData = store.getState().userSelections;
  const firstDayTwoMonthsAgo = formatToStandardDate(getFirstDayTwoMonthsAgo());
  firstDayTwoMonthsAgo.setDate(firstDayTwoMonthsAgo.getDate() + 1);
  const today = standardFormatToday();
  const yesterday = formatToStandardDate(today);
  yesterday.setDate(today.getDate() - 1);

  if (typeof currentStateData.clip_names_info !== "undefined") {
    currentStateData.clip_names_info.clip_full_obj.forEach((clip_obj) => {
      const clipStatus = checkStatus(clip_obj.date_start, clip_obj.date_end);

      if (typeof usedFor !== "undefined" && usedFor === "clip-overview") {
        if (formatToStandardDate(clip_obj.date_end) > firstDayTwoMonthsAgo) {
          clip_name_obj.push({ id: clip_obj.id, label: clip_obj.content });
        }
      } else {
        if (clipStatus === "Active") {
          clip_name_obj.push({ id: clip_obj.id, label: clip_obj.content });
        }
      }
    });
  }

  return erase_duplicates(clip_name_obj);
};

export const visual_names_in_range = () => {
  var visual_name_obj = [{}];
  const currentStateData = store.getState().userSelections;

  if (typeof currentStateData.visual_names_info !== "undefined") {
    currentStateData.visual_names_info.visual_names_full_obj.forEach((visual_obj) => {
      const visualStatus = checkStatus(visual_obj.date_start, visual_obj.date_end);

      if (visualStatus === "Active" && visual_obj.active === true) {
        visual_name_obj.push({ id: visual_obj.id, label: visual_obj.content });
      }
    });
  }

  return erase_duplicates(visual_name_obj);
};

export const setCampaignValuesForDynamicFilter = async (reduxKeywordToSaveValue, redux_param_name) => {
  const campaignDetails = store.getState().userSelections;
  // await fetchCampaignNames(); // wait for API
  const allCampaignNames = campaign_names_in_range(); // depends on fetched data?
  const ids = allCampaignNames.map(cmpgn => cmpgn.id);
  store.dispatch(updateStateData({
    [reduxKeywordToSaveValue]: {
      ...campaignDetails[reduxKeywordToSaveValue],
      [redux_param_name]: ids
    },
  }));

  return ids; // 🔑 return value to caller
};

export const setClipValuesForDynamicFilter = async (reduxKeywordToSaveValue, redux_param_name) => {
  const clipDetails = store.getState().userSelections;
  // await fetchClipNames(); // wait for API
  const allClipNames = clip_names_in_range(); // depends on fetched data?
  const ids = allClipNames.map(cmpgn => cmpgn.id);
  store.dispatch(updateStateData({
    [reduxKeywordToSaveValue]: {
      ...clipDetails[reduxKeywordToSaveValue],
      [redux_param_name]: ids
    },
  }));

  return ids; // 🔑 return value to caller
}

export const setLoopVisualValuesForDynamicFilter = async (reduxKeywordToSaveValue, redux_param_name) => {
  const clipDetails = store.getState().userSelections;
  // await fetchClipNames(); // wait for API
  const allClipNames = visual_names_in_range(); // depends on fetched data?
  const ids = allClipNames.map(cmpgn => cmpgn.id);
  store.dispatch(updateStateData({
    [reduxKeywordToSaveValue]: {
      ...clipDetails[reduxKeywordToSaveValue],
      [redux_param_name]: ids
    },
  }));

  return ids; // 🔑 return value to caller
}

// fetch regions for campaign
export const fetchRegionsForCampaign = async (campaignId) => {
  const regionsResponse = await sendApiRequest("regions/" + campaignId, "", "GET");
  if (regionsResponse.success === true) {
    store.dispatch(updateStateData({
      campaign_regions: regionsResponse.response.map(region => ({ value: region.name, label: region.name, nielsen_code: region.nielsenRegionCode }))
    }));
  } else {
    return [];
  }
};

// fetch Nielsen regions for campaign
export const fetchNielsenRegionsForCampaign = async (campaignId) => {
  const regionsResponse = await sendApiRequest("nielsen-regions/" + campaignId, "", "GET");
  if (regionsResponse.success === true) {
    // const testResponse = [
    //   {
    //     "id": 5,
    //     "nielsenRegionCode": "4",
    //     "nielsenRegionDesc": "Bayern",
    //     "lastEdit": "davoud",
    //     "timestampLastEdit": "2025-11-06T16:22:39.411224"
    //   }
    // ];
    store.dispatch(updateStateData({
      nielsen_campaign_regions: regionsResponse.response.map(region => ({ value: region.nielsenRegionCode, label: region.nielsenRegionCode }))
    }));
  } else {
    return [];
  }
};